export const actionTypePrefix = '@@header';
export const reduxKey = '@@header';
